import type { InsumoCultura } from './schemas';

// Formatação compartilhada do módulo de insumos (catálogo + ficha + modais).
export function fmtNum(n: number | null): string {
  if (n == null) return '—';
  return n.toLocaleString('pt-BR', { maximumFractionDigits: 3 });
}

// Dose por cultura: "0,5 L/ha" ou faixa "0,4 – 0,5 L/ha".
export function fmtDose(c: InsumoCultura, comUnidade: boolean): string {
  if (c.dose_min == null && c.dose_max == null) return '—';
  const faixa =
    c.dose_min != null && c.dose_max != null && c.dose_min !== c.dose_max
      ? `${fmtNum(c.dose_min)} – ${fmtNum(c.dose_max)}`
      : fmtNum(c.dose_max ?? c.dose_min);
  return comUnidade && c.dose_unidade ? `${faixa} ${c.dose_unidade}` : faixa;
}

export function capitaliza(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const CATEGORIA_LABEL: Record<string, string> = {
  fungicida: 'Fungicida',
  herbicida: 'Herbicida',
  inseticida: 'Inseticida',
  adubacao: 'Fertilizante',
  nutricao: 'Nutrição/Fisiologia',
  biologico: 'Biológico',
  especialidade: 'Especialidade',
  semente: 'Semente',
  adjuvante: 'Adjuvante',
  oleo_vegetal: 'Óleo vegetal',
  outro: 'Outro',
};

const FORMULACAO_LABEL: Record<string, string> = {
  SC: 'SC — suspensão concentrada',
  EC: 'EC — concentrado emulsionável',
  WG: 'WG — grânulos dispersíveis',
  SL: 'SL — concentrado solúvel',
  WP: 'WP — pó molhável',
  OD: 'OD — dispersão em óleo',
};
export function formulacaoLabel(f: string | null): string | null {
  if (!f) return null;
  return FORMULACAO_LABEL[f] ?? f;
}
